import { styled, Typography } from '@mui/material';

export const ErrorHelperText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.error,
  textTransform: 'none',
  textAlign: 'center',
}));
